import { render, staticRenderFns } from "./Secretarys.vue?vue&type=template&id=3459cd80&"
import script from "./Secretarys.vue?vue&type=script&lang=js&"
export * from "./Secretarys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports